import { AlertTriangle } from 'lucide-react'
import { useNavigate, useRouteError } from 'react-router-dom'

import WideButton from '@/components/common/button/WideButton'
import qbeeSadTransparent from '@/assets/images/qbee-character/qbee-happy-transparent.png'

const ErrorPage = () => {
  const navigate = useNavigate()
  const error = useRouteError() as Error

  const handleRefresh = () => {
    window.location.reload()
  }

  return (
    <div className='min-h-screen bg-gradient-to-r from-amber-400 to-yellow-300 flex items-center justify-center p-4'>
      <div className='max-w-md w-full text-center'>
        {/* 큐비 캐릭터 */}
        <div className='flex justify-center mb-8'>
          <img src={qbeeSadTransparent} alt='큐비 캐릭터' className='w-24 h-24' />
        </div>

        {/* 에러 메시지 */}
        <div className='bg-white/90 backdrop-blur rounded-2xl p-6 mb-6'>
          <div className='flex items-center justify-center gap-2 mb-3'>
            <AlertTriangle className='w-6 h-6 text-red-500' />
            <h1 className='text-2xl font-bold text-gray-800'>문제가 발생했어요</h1>
          </div>
          <p className='text-gray-600 leading-relaxed mb-4'>
            예상치 못한 오류가 발생했습니다.
            <br />
            잠시 후 다시 시도해 주세요.
          </p>

          {/* 개발환경에서만 에러 상세 정보 표시 */}
          {process.env.NODE_ENV === 'development' && error && (
            <details className='mt-4 text-left'>
              <summary className='cursor-pointer text-sm text-gray-500 mb-2'>에러 상세 정보</summary>
              <div className='bg-gray-100 p-3 rounded-lg text-xs font-mono text-gray-700 overflow-auto'>
                <div className='mb-2'>
                  <strong>Error:</strong> {error.message || '알 수 없는 오류'}
                </div>
                {error.stack && (
                  <div>
                    <strong>Stack:</strong>
                    <pre className='whitespace-pre-wrap mt-1'>{error.stack}</pre>
                  </div>
                )}
              </div>
            </details>
          )}
        </div>

        {/* 버튼들 */}
        <div className='space-y-3'>
          <WideButton
            handleClick={handleRefresh}
            buttonText='새로고침'
            className='flex items-center justify-center gap-2'
          />
          <WideButton
            handleClick={() => navigate('/')}
            buttonText='홈으로 가기'
            className='bg-amber-500 hover:bg-amber-600 text-white border-amber-500 flex items-center justify-center gap-2'
          />
        </div>

        {/* 도움말 */}
        <div className='mt-6 text-sm text-white/80'>
          <p>문제가 계속되면 고객센터로 문의해주세요</p>
        </div>
      </div>
    </div>
  )
}

export default ErrorPage
